import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getNarrative, resetAll } from 'modules/steps/actions';
import { setAutoNavigation } from 'routes/MainPage/modules/mainPage';
import Narrative from '../components';

function mapStateToProps(state) {
  return {
    actualContext: state.steps.context,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNarrative: bindActionCreators(getNarrative, dispatch),
    setAutoNavigation: bindActionCreators(setAutoNavigation, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Narrative));



// WEBPACK FOOTER //
// ./src/routes/Narrative/container/index.js